import { AnswerType } from '@data/types';
import React from 'react';
import { hash } from 'utilities/helper';

import DragButton from './DragButton';
import MultiTextButton from './MultiTextButton';
import RadialButton from './RadialButton';
import TextButton from './TextButton';

interface Props extends AnswerType {}

const Answer: React.FC<Props> = ({
  type,
  text,
  options,
  questionText = '',
  showLabels = false,
  ...props
}) => {
  switch (type) {
    case 'dragSingle':
      return (
        <DragButton
          text={text}
          questionText={questionText}
          options={options}
          showLabels={showLabels}
          type={type}
          size="large"
          {...props}
        />
      );
    case 'drag':
      return (
        <DragButton
          text={text}
          questionText={text}
          options={options}
          showLabels={showLabels}
          type={type}
          size="small"
          {...props}
        />
      );
    case 'multiSelect':
      return (
        <div className="flex flex-col md:flex-row md:items-center border-dashed border-b border-grey-dark pb-4">
          <div className="text-sm pt-2 md:w-1/2 md:pr-4 font-lightNormal">
            {text}
          </div>
          <div className="flex flex-row mt-4 max-w-1/2 lg:w-auto min-w-[50%] -mx-4">
            {options &&
              options.map((item) => (
                <div
                  key={hash(item)}
                  className="w-1/2 flex justify-center items-center px-4"
                >
                  <MultiTextButton
                    question={text}
                    value={item.value}
                    {...props}
                  />
                </div>
              ))}
          </div>
        </div>
      );

    case 'radial':
      return (
        <div className="flex bg-white py-2 xl:p-4 rounded-md shadow items-center">
          <div className="text-xs md:text-sm hidden xl:w-2/5 xl:block pr-4 font-lightNormal">
            {text}
          </div>
          {options &&
            options.map((item, index) => (
              <div
                key={hash(item)}
                className=" w-1/3 xl:w-1/5 flex justify-center items-center xl:px-4 relative"
              >
                <RadialButton
                  question={text}
                  value={item.value}
                  answerIndex={index}
                  {...props}
                />
              </div>
            ))}
        </div>
      );

    case 'button':
    default:
      return <TextButton question={questionText} value={text} {...props} />;
  }
};

export default Answer;
